<template>
  <div
    class="my-loyalty-banner-skeleton"
    aria-hidden="true"
  >
    <div class="grid-x grid-margin-x align-middle skeleton-row-gap">
      <!-- Card art -->
      <div class="cell small-12 medium-3 large-3 align-center display-flex">
        <AtomicUiSkeleton
          height="120px"
          width="190px"
          border-radius="8px"
        />
      </div>

      <!-- Offer copy -->
      <div class="cell small-12 medium-6 large-6">
        <AtomicUiSkeleton
          height="30px"
          width="70%"
          border-radius="4px"
          class="skeleton-mb-s"
        />
        <AtomicUiSkeleton
          height="16px"
          width="100%"
          border-radius="4px"
          class="skeleton-mb-xxs"
        />
        <AtomicUiSkeleton
          height="16px"
          width="85%"
          border-radius="4px"
          class="skeleton-mb-m"
        />
        <AtomicUiSkeleton
          height="20px"
          width="60%"
          border-radius="4px"
          class="skeleton-mb-xxs"
        />
        <AtomicUiSkeleton
          height="16px"
          width="90%"
          border-radius="4px"
        />
      </div>

      <!-- CTAs -->
      <div class="cell small-12 medium-3 large-3 flex-container flex-dir-column">
        <AtomicUiSkeleton
          height="44px"
          width="100%"
          border-radius="4px"
        />
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.skeleton-row-gap {
  row-gap: 32px;
}
.skeleton-mb-xxs {
  margin-bottom: 4px;
}
.skeleton-mb-s {
  margin-bottom: 12px;
}
.skeleton-mb-m {
  margin-bottom: 20px;
}
</style>
